import actionTypes from './actionTypes'
import BasePropertiesGenerator from './basePropertiesGenerator'

class UserAnalytics {

  constructor(repository, userGetter, sessionId) {
    this.repository = repository
    this.userGetter = userGetter
    this.sessionId = sessionId
  }

  async onTabFocusAction(page) {
    const session = {
      ...BasePropertiesGenerator.getBaseProperties(this.sessionId, this.userGetter, page, actionTypes.focusTab)
    }

    await this.repository.saveEvent(session)
  }

  async onTabBlurAction(page) {
    const session = {
      ...BasePropertiesGenerator.getBaseProperties(this.sessionId, this.userGetter, page, actionTypes.blureTab)
    }

    await this.repository.saveEvent(session)
  }
  /**
   * Function that generate data for 'openPage' action and saves this action
   * in IndexedDB
   * @param {string} page - the page name visited by the user
   */
  async onPageOpenAction(page) {
    const session = {
      ...BasePropertiesGenerator.getBaseProperties(this.sessionId, this.userGetter, page, actionTypes.openPage)
    }

    await this.repository.saveEvent(session)
  }

  /**
   * The save end session function.
   * Fired when the user has been closed the browser tab,
   * to form and save the end of the session.
   * _______ SessionType will be 'sessionEnd'
   */
  async onSessionEndAction(page) {
    const session = {
      ...BasePropertiesGenerator.getBaseProperties(this.sessionId, this.userGetter, page, actionTypes.sessionEnd)
    }

    await this.repository.saveEvent(session)
  }

  /**
   * The function how generate and save in IndexedDB start of the user session
   * It will work during the initialization of the page to which the user has moved
   * _______ SessionType will be 'sessionStart'
   * @param {string} page - the page name visited by the user
   */
  async onSessionStartAction(page) {
    const session = {
      ...BasePropertiesGenerator.getBaseProperties(this.sessionId, this.userGetter, page, actionTypes.sessionStart),
      args: JSON.stringify({
        browser: BasePropertiesGenerator.getBrowserName(),
        language: navigator.language,
        os: BasePropertiesGenerator.getOSName(),
        screen: { width: window.screen.width, height: window.screen.height }
      })
    }

    await this.repository.saveEvent(session)
  }
}

let analyticsInstance = null

export default function getUserAnalitycsTool(repository, userGetter, sessionId) {
  if (!analyticsInstance) {
    analyticsInstance = new UserAnalytics(repository, userGetter, sessionId)
  } else {
    analyticsInstance.userGetter = userGetter
  }
  return analyticsInstance
}
